import type { ComponentPropsWithoutRef } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Img } from '$src-components/atoms/Img';

import { Button, DesignType } from '@/components/atoms/Button';
import styles from './index.module.scss';

export interface StickyHeaderScrollToMapProps extends ComponentPropsWithoutRef<'div'> {
  readonly onBackToMapClick: () => void;
  readonly translations: {
    readonly backToMapLabel: string;
    readonly title: string;
  };
}

export function StickyHeaderScrollToMap({
  className,
  onBackToMapClick,
  translations: { backToMapLabel, title },
}: StickyHeaderScrollToMapProps): JSX.Element {
  return (
    <div className={classNames(StickyHeaderScrollToMap.displayName, styles.component, className)}>
      <div className={styles.stickyHeaderTitleSection}>
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.scrollToMapSection}>
        <Button
          className={styles.scrollToMapCTA}
          designType={DesignType.CTA_LIGHT}
          noIcon
          size="XS"
          onClick={onBackToMapClick}
        >
          {backToMapLabel}
        </Button>
        <Img
          className={styles.mapBackground}
          provider="cloudinary"
          src="/icons/map_lno2lf.png"
          alt=""
          height={80}
          width={160}
        />
      </div>
    </div>
  );
}
StickyHeaderScrollToMap.displayName = 'StickyHeaderScrollToMap';
